<template src="./CountryBrand.html"></template>

<script>
import analyticsTopMenu from "@/components/analytics/components/topMenu"
import Pagination from "@/components/components/pagination"
import BrandSelect from "@/components/components/BrandSelect"
import Chart from '@/components/brand/dynamics/components/Chart';
import SelfDateRangePicker from "@/components/components/SelfDataRagePicker"
import {config} from "@/config";

import {createNamespacedHelpers} from 'vuex'

const {mapGetters, mapActions} = createNamespacedHelpers('analytics/salesAnalyticsCountryBrand')

export default {
  name: "SalesAnalyticsCountry",
  components: {
    analyticsTopMenu,
    Pagination,
    Chart,
    BrandSelect,
    SelfDateRangePicker,
  },
  data() {
    return {
      showOverlay: false,
      currentPage: 1,
      perPage: 10,
      fieldsList: [
        {
          key: 'countryName',
          label: 'Страна',
          sortable: true
        },
        {
          key: 'request',
          label: 'Запросы',
          sortable: true
        },
        {
          key: 'requisition',
          label: 'КП',
          sortable: true
        },
        {
          key: 'orderCount',
          label: 'Заказы',
          sortable: true
        },
        {
          key: 'averageCheck',
          label: 'Средний чек',
          sortable: true
        },
        {
          key: 'conversion',
          label: 'Конверсия',
          sortable: true
        },
      ],
      sortBy: 'request',
      sortDesc: true,
      chartCountry: '',
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false
      },
      dateRange: {
        startDate: null,
        endDate: null,
      },
      exportUrl: config.apiUrl + '/brand-country/export',
    }
  },
  methods: {
    ...mapActions([
      'GET_DATA',
      'GET_HISTORY',
    ]),
    getChartDat: function () {
      if (this.FROM != null && this.TO != null && this.CURRENT_BRAND != null && this.CURRENT_COUNTRY_ID != null) {
        this.GET_HISTORY({th: this});
      }
    },
    updateTableData: function () {
      if (this.FROM != null && this.TO != null && this.CURRENT_BRAND != null) {
        this.GET_DATA({th: this});
      }
    },
    brandsChange: function (brandData)
    {
      if (brandData == null
          || brandData.id == undefined
          || (this.CURRENT_BRAND != null && this.CURRENT_BRAND.id == brandData.id)) {
        return
      }
      this.$store.commit('analytics/salesAnalyticsCountryBrand/CURRENT_BRAND', brandData);
      this.updateTableData()
      this.getChartDat()
    },
    selectCountry: function (countryId, countryName) {
      this.chartCountry = countryName
      this.$store.commit('analytics/salesAnalyticsCountryBrand/CURRENT_COUNTRY_ID', countryId);
      this.getChartDat()
    },
    updateRangePicker: function (val) {
      this.$store.commit('analytics/salesAnalyticsCountryBrand/FROM', val.from);
      this.$store.commit('analytics/salesAnalyticsCountryBrand/TO', val.to);
      this.getChartDat()
      this.updateTableData();
    },
  },
  computed: {
    ...mapGetters([
      'COUNTRY_DATA',
      'HISTORY_DATA1',
      'HISTORY_DATA2',
      'HISTORY_DATA3',
      'CURRENT_COUNTRY_ID',
      'CURRENT_BRAND',
      'FROM',
      'TO',
    ]),
    chartStyles () {
      return {
        height: '500px',
        position: 'relative'
      }
    },
    chartStylesSmall () {
      return {
        height: '350px',
        position: 'relative'
      }
    },
  },
  mounted() {
    if (this.$store.getters.getAllowSection.indexOf('analytics') === -1) {
      this.$router.push({name: 'permissionDenied'})
      return
    }

    this.dateRange.startDate = this.defaultDate
    this.dateRange.endDate = this.today

    this.$store.commit('analytics/salesAnalyticsCountryBrand/FROM', this.dateToString(this.dateRange.startDate));
    this.$store.commit('analytics/salesAnalyticsCountryBrand/TO', this.dateToString(this.dateRange.endDate));
    if (this.HISTORY_DATA1.length == 0 && this.HISTORY_DATA2.length == 0 && this.HISTORY_DATA3.length == 0) {
      this.getChartDat()
    }
  },
  created() {
    this.perPage = this.initPageSize()
    if (this.CURRENT_COUNTRY_ID != null) {
      this.currentCountryId = this.CURRENT_COUNTRY_ID
    }
  }
}
</script>

<style scoped>
.search-box {
  width: 375px;
  float: left
}
.total-search-box {
  width: 525px;
}
.query-link {
  color: #007bff;
  text-decoration: none;
  background-color: transparent;
  cursor: pointer;
}
.query-link:hover {
  text-decoration: underline;
}
.chart-col {
  position: fixed;
  width: 500px;
  margin: auto;
}
.chart-box {
  width: 800px;
  display: block;
}
.chart-box-small {
  width: 800px;
  display: block;
  padding-left: 1px;
}
</style>

<style>

</style>